document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-r3-concern-hero]').forEach((hero) => {
    const track = hero.querySelector('[data-r3-concern-track]');
    const dots = hero.querySelectorAll('[data-r3-concern-dot]');
    const chips = hero.querySelectorAll('[data-r3-concern-chip]');
    const slides = hero.querySelectorAll('[data-r3-slide-concern]');
    const search = hero.querySelector('[data-r3-concern-search]');

    let autoTimer = null;
    let currentIndex = 0;

    const stopAuto = () => {
      if (autoTimer) clearInterval(autoTimer);
      autoTimer = null;
    };

   const setActiveByKey = (key) => {
  chips.forEach((chip) => {
    const isActive = chip.dataset.concernKey === key;
    chip.classList.toggle('is-active', isActive);

    if (isActive) {
      const chipsWrap = chip.closest('.r3-concern-hero__chips');
      if (!chipsWrap) return;

      const chipLeft = chip.offsetLeft;
      const chipWidth = chip.offsetWidth;
      const wrapWidth = chipsWrap.clientWidth;

      chipsWrap.scrollTo({
        left: chipLeft - (wrapWidth / 2) + (chipWidth / 2),
        behavior: 'smooth'
      });
    }
  });
};
    const goToSlide = (index, stop = false) => {
      if (!track || !slides[index]) return;
      if (stop) stopAuto();

      currentIndex = index;

      track.scrollTo({
        left: track.clientWidth * index,
        behavior: 'smooth'
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      setActiveByKey(slides[index].dataset.r3SlideConcern);
    };

    const highlightTarget = (id) => {
      const target = document.getElementById(id);
      if (!target) return;

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.classList.add('r3-concern-highlight');

      setTimeout(() => {
        target.classList.remove('r3-concern-highlight');
      }, 1200);
    };

    if (track && slides.length) {
      autoTimer = setInterval(() => {
        goToSlide((currentIndex + 1) % slides.length);
      }, 4500);

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goToSlide(Number(dot.dataset.r3ConcernDot || 0), true);
        });
      });

      track.addEventListener('pointerdown', stopAuto);
      track.addEventListener('touchstart', stopAuto, { passive: true });
      track.addEventListener('wheel', stopAuto, { passive: true });

      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);

        if (index !== currentIndex && slides[index]) {
          currentIndex = index;

          dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === index);
          });

          setActiveByKey(slides[index].dataset.r3SlideConcern);
        }
      });
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        stopAuto();

        const key = this.dataset.concernKey;
        const targetId = this.dataset.targetId;

        chips.forEach(c => c.classList.remove('is-active'));
        this.classList.add('is-active');

        const slideIndex = Array.from(slides).findIndex((slide) => {
          return slide.dataset.r3SlideConcern === key;
        });

        if (slideIndex >= 0) {
          goToSlide(slideIndex, false);
        }

        if (targetId) {
          highlightTarget(targetId);
        }
      });
    });

    if (search) {
      search.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;

        const value = search.value.trim().toLowerCase();
        if (!value) return;

        const chip = Array.from(chips).find((c) => {
          return c.textContent.trim().toLowerCase().includes(value);
        });

        if (chip) chip.click();
      });
    }
  });
});